import ECheckImg from './img-echeck.svg'
import EUDDImg from './img-eudd.svg'

const Images = {
  ECheck: ECheckImg,
  EUDD: EUDDImg,
  DEFAULT: ECheckImg, // as a default icon for ECheck
}

export default Images
